import { FilterCategoryDisplayName } from "@hub/data/values/data-values.enum";
import { ApplicationType } from "@hub/models/elements/application-type";
import { Framework } from "@hub/models/elements/framework";
import { ProgrammingLanguage } from "@hub/models/elements/programming-language";
import { Topic } from "@hub/models/elements/topic";
import React from "react";
import styles from "./filter-category.module.css";
import { FilterOption } from "./filter-option";

interface FilterCategoryProps {
  categoryName: FilterCategoryDisplayName;
  options: ApplicationType[] | ProgrammingLanguage[] | Framework[] | Topic[];
  selectOption: (value: string) => void;
  filterValues: string[];
}

export const FilterCategory: React.FC<FilterCategoryProps> = ({
  categoryName,
  options,
  selectOption,
  filterValues,
}) => {
  const activeOptionsSet = new Set(filterValues);

  if (options.length === 0) {
    return null;
  }

  options.sort(function (a, b) {
    const optionA = a.displayName.toUpperCase();
    const optionB = b.displayName.toUpperCase();
    if (optionA < optionB) {
      return -1;
    }
    if (optionA > optionB) {
      return 1;
    }

    return 0;
  });

  return (
    <div className={styles.filterCategory}>
      <span className={styles.filterCategory__title}>{categoryName}</span>
      <div className={styles.filterList}>
        {options.map((option) => (
          <FilterOption
            checked={activeOptionsSet.has(option.value)}
            key={option.value}
            data={option}
            selectOption={selectOption}
          />
        ))}
      </div>
    </div>
  );
};
